import { Component } from "react";

// Bouton "recharger" : filet de sécurité générique, réutilisé par la
// messagerie quand le fil complet n'arrive pas.
export function BoutonRecharger() {
  return (
    <div style={{ display: "flex", justifyContent: "center", padding: 40 }}>
      <button
        type="button"
        title="Recharger"
        aria-label="Recharger"
        onClick={() => window.location.reload()}
        style={{
          background: "#FFFFFF",
          border: "1px solid #E5E7EB",
          borderRadius: 8,
          padding: 8,
          cursor: "pointer",
          color: "#374151",
        }}
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M3 12a9 9 0 1 1 3 6.7M3 12v6h6" />
        </svg>
      </button>
    </div>
  );
}

// Filet de sécurité autour d'une page chargée à la demande : si le morceau
// ne charge toujours pas après la reprise (voir chargement.js), on affiche
// un bouton pour recharger la page plutôt que de laisser l'appli vide.
export default class ErreurChargement extends Component {
  state = { erreur: false };

  static getDerivedStateFromError() {
    return { erreur: true };
  }

  render() {
    if (this.state.erreur) {
      return <BoutonRecharger />;
    }
    return this.props.children;
  }
}
